import EmailTemplateList from './EmailTemplateList.vue';
import CreateNewEmailTemplateAction from './CreateNewEmailTemplateAction.vue';

export default {
  EmailTemplateList,
  CreateNewEmailTemplateAction,
};
